module.exports = {"loader":"Generuji export","error":"Chyba generování exportu","success":"Export <b>{fileName}</b> byl úspěšně vygenerován"}